<template>
  <div class="row mx-0 slider-container home-carusel h-100">
    <b-carousel :interval="6000" controls indicators ride="true" v-if="slides">
      <b-carousel-slide
        v-for="(slide, index) in slides"
        :key="index"
        v-lazy-container="{
          selector: 'img',
          loading: require('@/../public/images/icons/small-loader.svg'),
        }"
      >
        <img
          slot="img"
          class="main-slide-img"
          :data-src="$config.storageUrlMain+slide.images.image"
          :src="$config.storageUrlMain+slide.images.image"
          @click="onSlideClick(slide)"
          :alt="'MagnetBet Casino '+ slide.title"
        />
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
export default {
  name: "Slider",
  methods: {
    onSlideClick(slide) {
      if (slide.link) {
        window.open(slide.link, "_blank");
      }
    }
  },
  mounted() {
    this.$store.dispatch('fetchSlides')
  },
  computed: {
    contacts() {
      return this.$store.getters.getMainSettings.socialLinks
    },
    slides(){
      return this.$store.getters.getSlides
    }
  }
};
</script>

<style>
.main-slide-img {
  max-width: 100vw;
  width: 100vw;
  height: calc(100vw / 4.8);
}

.slider-home-container img[lazy="loading"] {
  object-fit: none !important;
}

.slider-container > div {
  width: 100%;
}
.home-carusel .slide .carousel-control-prev,
.home-carusel .slide .carousel-control-next{
   top: unset!important;
   bottom: 20px!important;
   width: 35px;
   height: 35px;
   right: 50px;
   background-color: #ffffff80;
   border-radius: 8px;
   display: none;
  }
  .home-carusel .slide:hover .carousel-control-prev{
    padding-top: 7px;
    display: block;
  }
  .home-carusel .slide:hover .carousel-control-next{
    padding-top: 7px;
    display: block;
  }
  .home-carusel .slide .carousel-control-prev{
    left: calc(100% - 130px);
  } 

.carousel-indicators li {
  border-radius: 50%;
  height: 8px !important;
  width: 8px !important;
  border: none !important;
  background: #f1f1f1 !important;
  margin-right: 7px !important;
  margin-left: 7px !important;
}

.carousel-indicators li.active {
  background-color: #860019 !important;
}
@media screen and (max-width: 990px) {
  .home-carusel .slide:hover .carousel-control-prev{
    display: none!important;
  }
  .home-carusel .slide:hover .carousel-control-next{
    display: none!important;
  }
}

@media screen and (max-width: 500px) {
  .slider-home-container .carousel-indicators {
    display: none !important;
  }

  .slider-home-container img[lazy="loading"] {
    object-fit: contain !important;
  }
}
</style>
